import API from '../../services/API'
import {
    INVITATIONS_ACTION_ACCEPT,
    INVITATIONS_ACTION_CANCEL,
    INVITATIONS_ACTION_GET_INVITATIONS,
    INVITATIONS_ACTION_INVITE,
    INVITATIONS_ACTION_REJECT,
    INVITATIONS_GETTER,
    INVITATIONS_MUTATION_ENTIRE_INVITATIONS,
    INVITATIONS_MUTATION_SINGLE_INVITATION
} from './invitations-types'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        invitations: []
    },

    getters: {
        [INVITATIONS_GETTER]: state => state.invitations
    },

    mutations: {
        [INVITATIONS_MUTATION_ENTIRE_INVITATIONS] (state, payload) { state.invitations = payload },
        [INVITATIONS_MUTATION_SINGLE_INVITATION] (state, payload) {
            const index = state.invitations.findIndex(invitation => invitation.id === payload.id)
            state.invitations.splice(index, 1, payload)
        }
    },

    actions: {
        [INVITATIONS_ACTION_GET_INVITATIONS] ({commit}) {
            return new Promise(
                function (resolve, reject) {
                    API.loadInvitations()
                        .then((invitationsData) => {
                            for (let i in invitationsData.invitations) {
                                // processedInvitations[i] = this.invitations[i]
                                // processedInvitations.push(this.invitations[i])
                                if (invitationsData.invitations[i].status === 'cancelled') {
                                    invitationsData.invitations[i].status = 'Abgebrochen'
                                } else if (invitationsData.invitations[i].status === 'pending') {
                                    invitationsData.invitations[i].status = 'Hängig'
                                } else if (invitationsData.invitations[i].status === 'rejected') {
                                    invitationsData.invitations[i].status = 'Abgelehnt'
                                } else if (invitationsData.invitations[i].status === 'accepted') {
                                    invitationsData.invitations[i].status = 'Angenommen'
                                }
                            }
                            commit(INVITATIONS_MUTATION_ENTIRE_INVITATIONS, invitationsData.invitations)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [INVITATIONS_ACTION_INVITE] ({commit, state}, payload) {
            API.invite(payload)
                .then((invitationData) => {
                    OAlert.showSuccess('', i18n.t('feedback.guardianSucInvite'))
                    commit(INVITATIONS_MUTATION_SINGLE_INVITATION, invitationData)
                })
                .catch((error) => console.log(error.message))
        },
        [INVITATIONS_ACTION_ACCEPT] ({commit, state}, payload) {
            API.accept(payload)
                .then((invitationData) => {
                    OAlert.showSuccess('', i18n.t('feedback.guardianSucAccept'))
                    commit(INVITATIONS_MUTATION_SINGLE_INVITATION, invitationData)
                })
                .catch((error) => console.log(error.message))
        },
        [INVITATIONS_ACTION_REJECT] ({commit, state}, payload) {
            API.reject(payload)
                .then((invitationData) => {
                    OAlert.showSuccess('', i18n.t('feedback.guardianSucReject'))
                    commit(INVITATIONS_MUTATION_SINGLE_INVITATION, invitationData)
                })
                .catch((error) => console.log(error.message))
        },
        [INVITATIONS_ACTION_CANCEL] ({commit, state}, payload) {
            API.cancel(payload)
                .then((invitationData) => {
                    OAlert.showSuccess('', i18n.t('feedback.guardianSucCancel'))
                    commit(INVITATIONS_MUTATION_SINGLE_INVITATION, invitationData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/invitations.js